module.exports = __webpack_public_path__ + "static/img/advertisement3.8a7b1e06.png";